import type { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { anemicReference } from "@/types/backoffice/dto/common/references";

export const eventCategoryDtoSchema = anemicReference(branded.eventCategoryId);

export type TEventCategoryDto = z.infer<typeof eventCategoryDtoSchema>;
